<div
  [ngClass]="[
    icon === 'info' ? 'infoicon-section' : '',
    icon === 'error' ? 'erroricon-section' : '',
    icon === 'check' ? 'informationbox-section' : '',
    icon === 'emergency' ? 'emergencyicon-section' : ''
  ]"
  [style.max-width]="maxWidth"
  [class]="removeTopMargin ? 'noTopMargin' : ''"
>
  <div
    [ngClass]="[
      icon === 'info' ? 'goab-callout goab--infoicon' : '',
      icon === 'error' ? 'goab-callout goab--erroricon' : '',
      icon === 'check' ? 'goab-callout goab--informationbox' : '',
      icon === 'emergency' ? 'goab-callout goab--emergencyicon' : ''
    ]"
    class="d3-goab-callout"
    data-cy="informationbox-component"
  >
    <h3 *ngIf="title">
      <span data-cy="title">{{ title }}</span>
    </h3>
    <div class="callout-box-content" [class]="title ? 'content-margin' : ''">
      <ng-content></ng-content>
    </div>
  </div>
</div>
